/** 播放器相关事件 */
const DocPlayerEvt = 'DocPlayerEvt';

// 指定时间开始播放(用于回溯等相关功能等)
const START_PLAY_ON_TIME = `${DocPlayerEvt}_StartPlayOnTime`;
// 播放器切换到指定时间(原文区定位)
const PLAYER_TO_TIME = `${DocPlayerEvt}_PlayerToTime`;
// 下标标记高亮事件, 对应: HIGHLIGHTMARK_TIGNWU2
const MARK_INDEX_HIGHLIGHT = `${DocPlayerEvt}_MarkIndexHighlight`;

// 统一导出
export const DocPlayerEvts = {
  START_PLAY_ON_TIME,
  PLAYER_TO_TIME,
  MARK_INDEX_HIGHLIGHT,
};
